// Re-read the signed-in user's role until it holds a solution (solution sharing plan, stage 7).
// The creation worker writes the creator's role last (after any administrator copies), so a single
// read right after a create can miss the new solution. Polls at most `timeoutMs` (default 2 minutes);
// resolves with the last role payload read (or null), so the caller can dispatch setRole either way.
// `shouldStop` (optional): checked before every read; when it says so, the poll ends with null (for
// example the user signed out and someone else signed in on the same tab).
import { rolesApi } from "services/roles";

export async function waitForSolutionInRole(dispatch, roleId, serviceId, { timeoutMs = 120000, intervalMs = 3000, shouldStop } = {}) {
  const sid = String(serviceId);
  const until = Date.now() + timeoutMs;
  let last = null;
  for (;;) {
    if (shouldStop && shouldStop()) return null;
    const sub = dispatch(rolesApi.endpoints.getSpecificRole.initiate(roleId, { forceRefetch: true }));
    const res = await sub;
    sub.unsubscribe();
    const payload = res && res.isSuccess && res.data ? res.data.payload : null;
    if (payload) last = payload;
    const holds = !!(payload && (payload.services || []).some((s) => s && (String(s.serviceId) === sid || String(s.serviceId) === "*")));
    if (holds || Date.now() + intervalMs > until) return last;
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
}
